// Mutation hook - start testu deliverability stopki (queue + DelayStamp 60s).
// POST /api/ui/sales-crm/mailbox/test-signature-deliverability
// Sprint 3 v4.1. Wynik pollowany przez useGetTestSignatureDeliverabilityResult.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPostTestSignatureDeliverabilityResponse } from 'api/types/signature';

const postTestSignatureDeliverability = (): Promise<IPostTestSignatureDeliverabilityResponse> =>
  axios.post('/sales-crm/mailbox/test-signature-deliverability');

export const usePostTestSignatureDeliverability = (
  options?: UseMutationOptions<IPostTestSignatureDeliverabilityResponse, IError, void>
) =>
  useMutation<IPostTestSignatureDeliverabilityResponse, IError, void>(
    postTestSignatureDeliverability,
    options
  );
